export default __webpack_public_path__ + "static/media/mgilogo.72047e8b.svg";